import type { SvgProps } from "../types";

export const SleepSvg = ({
  width = "100px",
  height = width,
  color = "#000000",
}: SvgProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 400 400" fill="none">
      <title>Sleep</title>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M332.834 158.701C332.834 142.39 335.435 122 304.022 122C272.608 122 247.525 138.833 247.525 163.484C247.525 188.136 270.164 215.458 294.73 215.458C319.295 215.458 332.834 175.013 332.834 158.701Z"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M54.9618 224.685C57.7485 223.694 58.7129 221.016 60.088 219.017C121.001 170 223.001 170 263.099 216.628"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="14"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M346.523 148.15C347.565 154.784 346.158 224.685 346.478 233.326C347.494 260.785 346.821 264.424 346.192 274.972C346.113 276.313 346.4 277.688 346.158 279"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M344.744 250.428C341.365 250.006 66.1932 248.541 57.4404 248.561C107.431 263.941 273.229 259.893 302.065 250.428"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="14"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M54 275.708C55.4577 260.99 55.8753 149.11 55.704 142.39"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M284.427 142.39C283.028 145.871 284.087 149.202 285.829 152.584"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
